/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { shouldStartRendering } from "selectors/documentSelectors";
import { trackSwitchToLiquidMode } from "analytics/events";

import FileHTML from "@react/react-spectrum/Icon/FileHTML";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";

import * as constants from "constants/constants";
import { getLiquidModeApis } from "publicApis/LiquidModeApi";

const mapStoreToProps = (stores, ownProps) => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const liquidModeApis = getLiquidModeApis(stores);
  return {
    useModernViewer: getShouldUseModernViewer(stores),
    icon: FileHTML,
    clickHandler: () => {
      if (!liquidModeApis.isDocumentInLiquidModeView()) {
        liquidModeApis.enterLiquidModeView();
        trackSwitchToLiquidMode();
      } else {
        liquidModeApis.exitLiquidModeView();
      }
    },
    className: ownProps.className || "",
    ariaLabel: "lm.switch",
    tooltipString: "lm.switch",
    tooltipPlacement: useModernViewer ? constants.TOOLTIP_LEFT_PLACEMENT : constants.TOOLTIP_TOP_PLACEMENT,
    tooltipDelay: constants.TOOLTIP_DELAY,
    shouldDisable: !shouldStartRendering(stores) || !liquidModeApis.isLiquidModeViewEnabled(stores)
  };
};

const LMViewSwitcherContainer = inject(mapStoreToProps)(ButtonWrapper);

export { LMViewSwitcherContainer };
